module.exports = __webpack_public_path__ + "media/leather_4.071d4ce9.webm";